var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "text-h6",
      staticStyle: {
        display: "inline-flex",
        "flex-direction": "row",
        "will-change": "transform, opacity, background-color, color",
      },
      attrs: { grow: "" },
    },
    [
      _c("span", { staticClass: "hidden-sm-and-down" }, [
        _vm._v("Results for job: "),
      ]),
      _vm._v(" "),
      _vm.inEdit
        ? [
            _c(
              "div",
              { staticClass: "custom-field-container" },
              [
                _c(
                  "v-tooltip",
                  {
                    attrs: {
                      bottom: "",
                      color: "error",
                      value: _vm.errorState,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "input-wrapper",
                                  class: {
                                    overflow: _vm.errorState,
                                    exists: _vm.inputValue.length > 0,
                                  },
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.inputValue,
                                        expression: "inputValue",
                                      },
                                    ],
                                    ref: "inputField",
                                    staticClass: "field-input mono",
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.ticket,
                                      autocomplete: "off",
                                    },
                                    domProps: { value: _vm.inputValue },
                                    on: {
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        !_vm.errorState
                                          ? _vm.saveName()
                                          : () => {}
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.inputValue = $event.target.value
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "active-line" }),
                                  _vm._v(" "),
                                  _c(
                                    "transition",
                                    { attrs: { name: "fade" } },
                                    [
                                      _c(
                                        "button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.inputValue.length > 0,
                                              expression:
                                                "inputValue.length > 0",
                                            },
                                          ],
                                          staticClass: "clear-btn",
                                          attrs: { type: "button" },
                                          on: { click: _vm.clearInput },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                color: _vm.errorState
                                                  ? "error"
                                                  : "inherit",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1695389661
                    ),
                  },
                  [_vm._v(" "), _c("span", [_vm._v("Max 40 characters")])]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: {
                  icon: "",
                  small: "",
                  title: "Save job name",
                  ripple: false,
                  disabled: _vm.errorState,
                },
                on: { click: _vm.saveName },
              },
              [_c("v-icon", [_vm._v(_vm._s(_vm.$MDI.Check))])],
              1
            ),
          ]
        : [
            _c("small", { staticClass: "ticket mono" }, [
              _vm._v("\n            " + _vm._s(_vm.toDisplay) + "\n        "),
            ]),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "edit-btn",
                attrs: {
                  icon: "",
                  small: "",
                  ripple: false,
                  title: "Edit job name",
                },
                on: { click: _vm.enableEdit },
              },
              [
                _c("v-icon", { attrs: { dense: "" } }, [
                  _vm._v(_vm._s(_vm.$MDI.Pencil)),
                ]),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }